import React, { useRef } from "react";
import ReactPlayer from "react-player";
import screenfull from "screenfull";
import "./VideoPlayer.css";
import { Container, Grid, Typography } from "@mui/material";
import { useState } from "react";
import FormatTime from "../../Functions/FormatTime";
import { useEffect } from "react";
import TestVideo from "../../Assets/Videos/Regions-Filters.mp4";
import { Button } from "@ux/balance-react";

const VideoPlayer = ({videoPath, closeVideo}) => {
    return(
        <>
            <Grid container justifyContent={"center"} >
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <div className="playerContainer" >
                        <div className="playerWrapper">
                            <ReactPlayer
                                width={'100%'} 
                                height={'100%'}
                                playing={true}
                                controls
                                config={{ 
                                    file: { 
                                        attributes: {
                                            controlsList: 'nodownload'
                                        }
                                    }
                                }}
                                url={require("../../Assets/Videos/" + videoPath)}
                            />
                        </div>
                        <div className="closeBtn">
                            <Button
                                text="X"
                                clickMethod={closeVideo}
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </>
    );
}

export default VideoPlayer